import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=1f5272e7&"
import script from "./JobsList.vue?vue&type=script&lang=ts&"
export * from "./JobsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports